/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import { SignUpUserProps } from "./components";

const is = require("is_js");

const SERVICE_NAME = "SignUpPageService";
const log: any = LoggerModule.getInstance();

export class SignUpPageService {
  private static instance: SignUpPageService;
  private vapp: VApplication;
  private loginRestAPI: string;
  private headers: any;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
    this.loginRestAPI = props?.loginRestAPI;
    this.headers = props?.headers;
  }

  public static getInstance(props: any = {}): SignUpPageService {
    if (!SignUpPageService.instance) {
      SignUpPageService.instance = new SignUpPageService(props);
    }
    return SignUpPageService.instance;
  }

  public async signUpUser(args: SignUpUserProps) {
    log.info(`user SignIn`, args);
    let _args = {
      ...args,
      apiURL: this.loginRestAPI,
      headers: this.headers,
    };
    const agent = getAgent();
    return agent.getSignUpUser(_args);
  }
}
